/**
 * Time series chart component using Recharts.
 */

import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { format } from 'date-fns';
import type { TimeSeriesPoint } from '@/api/schemas';
import './time-series.scss';

export interface TimeSeriesProps {
  data: TimeSeriesPoint[];
  height?: number;
}

export function TimeSeries({ data, height = 300 }: TimeSeriesProps) {
  if (!data || data.length === 0) {
    return (
      <div className="time-series__empty">
        No data available
      </div>
    );
  }

  const chartData = data.map((point) => ({
    ...point,
    t: format(new Date(point.t), 'MMM dd HH:mm'),
  }));

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--of-border)" />
        <XAxis dataKey="t" stroke="var(--of-text-muted)" />
        <YAxis stroke="var(--of-text-muted)" />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="clicks" stroke="var(--of-flow-blue)" name="Clicks" />
        <Line type="monotone" dataKey="uniques" stroke="var(--of-success)" name="Uniques" />
        <Line type="monotone" dataKey="bots" stroke="var(--of-error)" name="Bots" />
      </LineChart>
    </ResponsiveContainer>
  );
}

